<template>
  <div class="graphic panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
